import {SubmitHandler, UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {login} from '../../../../api/login';
import {
  getIsTurnstileEnabled,
  resetTurnstile,
  TURNSTILE_FORM_FIELD,
} from '../../../../turnstile/TurnstileWidget';
import {getRedirectPath} from './getRedirectPath';
import type {FormInputs} from './Form';

export const useSubmitHandler = ({
  handleSubmit,
  setError,
  clearErrors,
  setValue,
}: Pick<
  UseFormReturn<FormInputs>,
  'handleSubmit' | 'setError' | 'clearErrors' | 'setValue'
>) => {
  const {t} = useTranslation();

  const onSubmit: SubmitHandler<FormInputs> = async ({
    email,
    password,
    [TURNSTILE_FORM_FIELD]: turnstileToken,
  }) => {
    clearErrors('root.serverError');

    if (
      !turnstileToken &&
      (await getIsTurnstileEnabled(window.location.hostname))
    ) {
      setError(TURNSTILE_FORM_FIELD, {
        type: 'manual',
        message: 'Turnstile verification is required',
      });
      return;
    }

    try {
      await login({email, password}, turnstileToken);
      window.location.href = getRedirectPath(
        window.location.search,
        window.location.pathname
      );
    } catch {
      setError('root.serverError', {message: t('login.errors.generic')});
      if (turnstileToken) {
        setValue(TURNSTILE_FORM_FIELD, '');
        resetTurnstile();
      }
    }
  };

  return handleSubmit(onSubmit);
};
